import { AutogenModelPayee401kFund, AutogenRowPayee401kFund } from "./autogen/AutogenModelPayee401kFund";

export class ModelPayee401kFund extends AutogenModelPayee401kFund<RowPayee401kFund> {
	constructor() {
		super(RowPayee401kFund);
	}
}

export class RowPayee401kFund extends AutogenRowPayee401kFund {
}
